//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 25.04.2016.
 */

(function () {

    'use strict';

     const dateSuffix = (new Date()).getTime();

    function loadCssFiles(cssFiles) {
        var cssTags = cssFiles.map(function (cssFile) {
            return '<link rel="stylesheet" href="' + cssFile + '?v='+ dateSuffix + '" type="text/css" />';
        }); 

        $('head').append(cssTags.join('\n'));
    }

    function loadJsFile(jsFile) {

        var deferred = $.Deferred();
        var script = document.createElement('script');
        script.defer = true;
        script.src = jsFile + '?v=' + dateSuffix;

        script.onload = function () {
            deferred.resolve();
        };

        script.onerror = function () {
            console.log('Cannot load JavaScript file ', jsFile);
            deferred.reject();
        };

        document['head'].appendChild(script);

        return deferred.promise();
    }

    function loadScripts(scripts) {
        return scripts.reduce(function(promise, script){
            return promise.then(loadJsFile.bind(null, script));
        }, $.when());
    }

    function tryLoadExtensionFile(extensions, extensionName) {

        var deferred = $.Deferred();

        $.getJSON(extensions[extensionName] + '/ui/extension-files.json')
            .then((fileList) => {
                loadAssets(fileList).then(() => {
                    deferred.resolve(true);
                }).fail(() => {
                    deferred.resolve(false);
                });
            })
            .fail(() => {
                deferred.resolve(false);
            });

        return deferred.promise();
    }

    function cleanExtensionList(extensions) {

        var promises = [];

        var extensionsForIterate = angular.copy(extensions);

        $.each(extensionsForIterate, (extension) => {

            var p = tryLoadExtensionFile(extensions, extension).then((succeeded) => {

                if (!succeeded) {
                    console.log(`Removing ${extensionsForIterate[extension]} from extensions`);
                    extensions.splice($.inArray(extensionsForIterate[extension], extensions), 1);
                }
            });
            promises.push(p);
        });

        return $.when.apply($, promises);
    }

    function loadAssets(fileList) {

        loadCssFiles(fileList.css);
        return loadScripts(fileList.js);
    }

    function loadExtensions() {

        var extensions;

        $.getJSON('container/ui/extension-list.json').then((data) => {

            extensions = data.extensions.map(function (ext) { return ext.abbreviation; });


            if (!data.options || !data.options.dev) {
                cleanExtensionList(extensions).then(() => {
                    bootstrapAngular(extensions);
                });
            } else {
                bootstrapAngular(extensions);
            }
        });
    }

    function bootstrapAngular(extensions) {

        window._keycloak = new Keycloak('/container/ui/app/core/configs/keycloak.json');
        window._keycloak.init({
            onLoad: 'login-required'
        }).then((authenticated) => {
            console.log(window._keycloak.token);

            if (authenticated) {
                var modules = ['container'].concat(extensions);
                angular.bootstrap(document, modules);
            }
            
        }).catch((error) => {
            alert('failed to initialize');
            console.log('failed to initialize: ' + JSON.stringify(error));
        });       

        
        window._keycloak.onTokenExpired = () => {
            console.log('Token expired '+new Date());
        }

    }




    var auth = {};

    $(document).ready(function ($http, KEYCLOAK_URL) {
        loadExtensions();
    });



})();